"use client";
import React, { useEffect, useState } from "react";

interface ProgressBarProps {
  count?: number;
}

export const ProgressBar = ({ count = 3 }: ProgressBarProps) => {
  const circles = Array.from({ length: count });

  return (
    <div className="w-full px-2 my-7">
      <div className="relative flex flex-col items-start justify-between h-64 pl-2 md:flex-row md:h-auto md:justify-between md:pl-0 w-full">
        {/* Circles */}
        {circles.map((_, index) => (
          <div
            key={index}
            className={`
            z-10 w-6 h-6 rounded-full shadow
            ${index === 0 ? "bg-primary-500" : index === count - 1 ? "bg-red-500" : "bg-yellow-400"}
            `}
          />
        ))}

        <div
          className="
        absolute left-4 top-0 bottom-0 w-2 h-full rounded-full bg-gradient-to-b from-green-500 via-yellow-500 to-red-400 z-0
        md:left-0 md:right-0 md:top-1/2 md:bottom-auto md:w-full md:h-2 md:-translate-y-1/2 md:bg-gradient-to-r
          "
        />
      </div>
    </div>
  );
};

export default ProgressBar;

interface ScrollProgressBarProps {
  sections: { id: string; label: string }[];
}

export const ScrollProgressBar = ({ sections }: ScrollProgressBarProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const elements = sections.map((s) => document.getElementById(s.id));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sections.findIndex((s) => s.id === entry.target.id);
            setActiveIndex(index);
          }
        });
      },
      { threshold: 0.5 }
    );

    elements.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, [sections]);

  const handleClick = (id: string, index: number) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setActiveIndex(index);
  };

  return (
    <div className="sticky top-[107px] md:top-[150px] lg:top-32 z-20 bg-white py-2 px-4 ">
      <div
        className={`relative ${sections.length > 5 ? "overflow-x-auto scrollbar-hide" : ""}`}
      >
        <div
          className={`relative flex items-center ${sections.length > 6 ? "gap-20 pl-4" : "justify-between w-full pl-4"}`}
        >
          {/* Circles */}
          {sections.map((section, idx) => (
            <button
              key={section.id}
              type="button"
              onClick={() => handleClick(section.id, idx)}
              className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white text-xs font-medium shadow-md transition-colors
      ${idx === activeIndex ? "bg-primary-500" : "bg-grey-400"}
    `}
            >
              Day
              <span className="typography-sub-h3 font-medium"> {idx + 1}</span>
            </button>
          ))}

          <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-2 z-[-1] rounded-full bg-gradient-to-r from-green-500 to-white" />
        </div>
      </div>
    </div>
  );
};
